import { qsa, toggle } from "@fluorescent/dom";

import { section } from "@/glow";
import { emit, on } from "@/glow/events";

const slideshowOpts = {
  adaptiveHeight: false,
  fade: true,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true,
  draggable: false,
};

const selectors = {
  announcements: ".announcement-bar__slide",
};

const modifiers = {
  active: "is-active",
};

const rootVars = {
  announcementBar: "--announcement-height",
};

section("announcement-bar", {
  listeners: [],
  onLoad() {
    this.announcements = qsa(selectors.announcements, this.container);

    const { timing } = this.container.dataset;

    slideshowOpts.autoPlay = parseInt(timing);

    this._init();

    this._setRootVar(
      rootVars.announcementBar,
      this.announcements.length ? this.container.offsetHeight : 0
    );
  },

  _init() {
    if (this.announcements.length > 1) {
      import(flu.chunks.flickity).then(({ Flickity }) => {
        this.slideshow = new Flickity(this.container, {
          ...slideshowOpts,
          on: {
            // Need to add a modifier to animate after the first slide has changed
            change: index => {
              this.announcements.forEach((element, i) => {
                toggle(element, modifiers.active, i === index);
              });
            },
          },
        });

        emit("announcement-bar:initialized");
      });
    }
  },

  _setRootVar(name, value) {
    document.documentElement.style.setProperty(name, `${value}px`);
  },

  handleBlockSelect(slideIndex) {
    this.slideshow.stopPlayer();
    this.slideshow.select(slideIndex);
  },

  onSelect() {
    emit("sticky-header:reload", () => {});
  },

  onBlockSelect({ target }) {
    if (this.slideshow) {
      this.handleBlockSelect(target.dataset.index);
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("announcement-bar:initialized", () => {
          this.handleBlockSelect(target.dataset.index);
        })
      );
    }
  },

  onBlockDeselect() {
    if (this.slideshow) {
      this.slideshow.playPlayer();
    } else {
      // Listen for initalization if slideshow does not exist
      this.listeners.push(
        on("announcement-bar:initialized", () => {
          this.slideshow.playPlayer();
        })
      );
    }
  },

  onUnload() {
    this.slideshow && this.slideshow.destroy();
    this.resizeObserver.disconnect();
    this.listeners.forEach(unsubscribe => unsubscribe());
  },
});
